import { GSEndpoint } from "../models/endpoint";
import { BaseScopes } from "../models/scopes";
import { User } from "../models/user";

interface UploadI {
    message: string;
}

export class PostUpload extends GSEndpoint<FormData, UploadI> {
    constructor() {
        super("upload", "POST", [BaseScopes.MAINTAIN]);
    }

    async request(req: FormData, user: User): Promise<UploadI> {
        return await this.makeRequest(req, user, {
            "Content-Type": "multipart/form-data"
        });
    }
}
